import { useIntercom } from 'react-use-intercom'

import { useMeBillingQuery, useMeQuery } from '../../store/api'
import { PlanPackageType } from '../../store/types/billing'
import {
  IntercomEvent,
  shouldTrackIntercomEvent,
} from '../helpers/getIntercomMsg'

export default function useIntercomInternal() {
  const { data: me } = useMeQuery()
  const { data: billingData, isSuccess: isBillingDataSuccess } =
    useMeBillingQuery()

  const { trackEvent } = useIntercom()
  const trackEventInternal = (event: string, metaData?: object | undefined) => {
    if (shouldTrackIntercomEvent(me)) {
      trackEvent(event, metaData)
    }
  }

  const trackFeatureDisabledInternal = (type: string) => {
    if (isBillingDataSuccess) {
      const currentIndex = Object.keys(PlanPackageType).indexOf(
        billingData?.package_type!,
      )
      if (currentIndex !== Object.keys(PlanPackageType).length - 1) {
        if (shouldTrackIntercomEvent(me)) {
          let nextPackage = Object.keys(PlanPackageType)[currentIndex + 1]
          if (type === 'Product History') {
            nextPackage = 'L'
          }
          trackEvent(IntercomEvent['feature-disabled'], {
            Type: type,
            'Current Package': billingData?.package_type,
            'Next Package': nextPackage,
          })
        }
      }
    }
  }

  return {
    trackEventInternal,
    trackFeatureDisabledInternal,
  }
}
